import moment from 'moment';

export class PatientConnectionService {
    constructor(AppStoreService, AppUserService, DataApiService) {
        'ngInject';
        this.AppStoreService = AppStoreService;
        this.AppUserService = AppUserService;
        this.DataApiService = DataApiService;

        this.model = {
            patient: {},
            careTeam: {},
            profiles: [],

            patientConnection: {
                connectionStatus: '',

                connectionUser: {
                    type: '',
                    email: '',
                    firstName: '',
                    middleInitial: '',
                    lastName: '',
                    relationship: ''
                },
                verifyFields: [],
            }
        };
    }

    signupPatientConnectionUser(token, email, password, hipaaAuthorized, hipaaAuthorizedAt, hipaaAuthorizedVersion) {
        return this.AppUserService.signupPatientConnectionUser({ token, email, password, hipaaAuthorized, hipaaAuthorizedAt, hipaaAuthorizedVersion }).then((result) => {
            this.AppStoreService.set('global.isNewUser', true);
            return result;
        });
    }

    getPatientConnectionUser(emailToken) {
        return this.DataApiService.getPatientConnectionUser(emailToken)
            .then((result) => {
                return result
            });
    }

    getPatientConnection(emailToken) {
        return this.DataApiService.getPatientConnection(emailToken)
            .then((conn) => {
                this.model = this.parseConnectionResp(conn);
                return angular.copy(this.model);
            });
    }

    parseConnectionResp(connResp) {
        let { patient, careTeam, profiles, schedule } = connResp;
        let { connectionStatus, connectionUser, verifyFields, extra, registrationType, registrationRelationship } = connResp.patientConnection;
        let model = {
            patient,
            careTeam,
            schedule,
            profiles: profiles.map(pr => {
                return Object.assign({}, pr, pr.patient);
            }),
            patientConnection: {
                connectionStatus,
                connectionUser: {
                    type: registrationType,
                    firstName: extra.patient.firstName,
                    middleInitial: extra.patient.middleInitial,
                    lastName: extra.patient.lastName,
                    relationship: registrationRelationship,
                },
                verifyFields,
            }
        };

        return model;
    }

    verifyPatientConnection(emailToken, verifyFields, confirmUser) {
        let { dob, zipCode } = verifyFields;
        verifyFields = {
            patientDob: moment.utc(moment(dob).format('YYYY-MM-DD')).toISOString(),
            patientZipCode: zipCode
        };
        return this.AppUserService.verifyPatientConnection(emailToken, verifyFields, confirmUser)
            .then((conn) => {
                if (conn) {
                    this.model = this.parseConnectionResp(conn);
                    return angular.copy(this.model);
                }
            });
    }

    addAsNewProfile(emailToken) {
        return this.DataApiService.addPatientConnectionProfile(emailToken)
            .then((conn) => {
                this.model = this.parseConnectionResp(conn);
                return angular.copy(this.model);
            });
    }

    mergeToProfile(emailToken, mergeToProfile) {
        return this.DataApiService.mergePatientConnectionProfile(emailToken, mergeToProfile.profileId)
            .then((conn) => {
                this.model = this.parseConnectionResp(conn);
                return angular.copy(this.model);
            });
    }

    cancelShare(emailToken) {
        return this.DataApiService.denyPatientConnection(emailToken)
            .then((conn) => {
                this.model = this.parseConnectionResp(conn);
                return angular.copy(this.model);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/patientConnection.service.js